<template>

<div class="row plain-element">
  <div v-if="!isLoggedIn()" class="dashboard-cards">
    <NoPermissionComponent/>
  </div>
    <div v-if="getUsername() && getServiceSitesAndSeu()" class="dashboard">
    <div class="row plain-element top-menu">
      <ul>
        <li>
          <router-link :to="{name: 'home'}" class="horizontal-link">Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'action-search'}" class="horizontal-link underline-blue">Action Search
          </router-link>
        </li>
        <li>
          <a href="/action-report" class="horizontal-link">Action Report
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="row plain-element">
    <div class="row row-opportunities">
       <div class="row plain-element">
          <div v-if="getServiceSitesAndSeu()" class=" col col-12 col-sm-12 col-md-3 col-lg-3 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">Site </label>
              </div>
              <select v-model="site" name="site" id="site" @change="clearSeu()">
                <option value="" selected> All Sites</option>
                <option v-for="(key, value, index) in getServiceSitesAndSeu()" :key="index" :value="value">
                  {{ getSiteNames()[value] }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="getServiceSitesAndSeu()" class=" col col-12 col-sm-12 col-md-3 col-lg-3 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">SEU</label>
              </div>
              <select v-model="seu" name="seu" id="seu" @change="clearSearch()">
                <option value="" selected> All SEU</option>
                <option v-for="(element, index) in getServiceSitesAndSeu()[site]" :key="index">
                  {{ element }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="getServiceSitesAndSeu()" class=" col col-12 col-sm-12 col-md-2 col-lg-2 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">Status</label>
              </div>
              <select v-model="status" name="status" id="status" @change="clearSearch()">
                <option value="open" selected>open</option>
                <option value="closed - resolved" selected> closed - resolved</option>
                <option value="closed - unresolved" selected> closed - unresolved</option>
                <option value="" selected> All</option>
              </select>
            </div>
          </div>
          <div v-if="getServiceSitesAndSeu()" class=" col col-12 col-sm-12 col-md-1 col-lg-1 plain-element">

          </div>
          <div class=" col col-12 col-sm-12 col-md-5 col-lg-3 plain-element text-end">
            <div v-if="getServiceSitesAndSeu()" class="input-field  col col-12 col-sm-12 col-form">
              <div class="row searchbox-wrapper">
                <div class="row plain-element text-start">
                  <label class="label-search">Table Filter</label>
                </div>
                <input class="form-control" id="keyWordSearchbox" type="text" placeholder="e.g. Steam"
                       aria-label="e.g. Steam" v-model="search">
              </div>
            </div>
          </div>
       </div>
      <p class="w-100"></p>
      <div v-if="getUsername() && getLoader() === true" class="row">
        <div class="loader" id="loader"></div>
      </div>
      <div v-if="getActions()  && getLoader() === false" class="row plain-element">
        <div v-if="getResultCount() > 0" class="col col-sm-3 col-md-3 col-lg-3 plain-element text-start">
          <h6> {{ keywordFilteredList.length }} Results</h6>
        </div>
        <div class="col col-sm-6 col-md-6 col-lg-6 plain-element">
        </div>
        <div v-if="getResultCount() && keywordFilteredList.length > 0" class="col col-sm-3 col-md-3 col-lg-3 col-results plain-element text-end">
          <a target="_blank" v-if="site!=='' && seu===''" :href="'/api/site-search-actions-download/' + site + '/'"
             class="btn btn-report">
             Download
          </a>
          <a target="_blank" v-else-if="site!=='' && seu!==''"
             :href="'/api/seu-download/' + site + '/' + seu + '/'"
             class="btn btn-report">
             Download
          </a>
        </div>
      </div>
      <p class="w-100"></p>
      <div id="parent">
        <div id="child">
          <table v-if="getActions() && getLoader() === false"  id="searchTable">
            <thead v-if="keywordFilteredList.length > 0">
              <tr>
                <th @click="sortTableNew(0)" class="text-start">Action No.
                  <span class="icon-stack">
                          <span class="material-icons caret-down">expand_more</span>
                          <span class="material-icons caret-up">expand_less</span>
                      </span>

                </th>
                <th @click="sortTableNew(1)" class="text-start">Status
                  <span class="icon-stack">
                      <span class="material-icons caret-down">expand_more</span>
                      <span class="material-icons caret-up">expand_less</span>
                  </span>
                </th>
                <th @click="sortTableNew(2)" class="text-start">Created
                  <span class="icon-stack">
                          <span class="material-icons caret-down">expand_more</span>
                          <span class="material-icons caret-up">expand_less</span>
                      </span>
                </th>
                <th @click="sortTableNew(3)" class="text-start">SEU
                  <span class="icon-stack">
                          <span class="material-icons caret-down">expand_more</span>
                          <span class="material-icons caret-up">expand_less</span>
                      </span>
                </th>
                <th @click="sortTableNew(4)" class="text-start">Event Type
                  <span class="icon-stack">
                          <span class="material-icons caret-down">expand_more</span>
                          <span class="material-icons caret-up">expand_less</span>
                      </span>
                </th>
                <th @click="sortTableNew(5)" class="text-start">Action To
                  <span class="icon-stack">
                          <span class="material-icons caret-down">expand_more</span>
                          <span class="material-icons caret-up">expand_less</span>
                      </span>
                </th>
                <th class="text-center th-description">Comment/Response</th>
                <th @click="sortTableCurrencyInt(7)" class="text-center">Total Cost
                  <span class="icon-stack">
                      <span class="material-icons caret-down">expand_more</span>
                      <span class="material-icons caret-up">expand_less</span>
                  </span>
                </th>
                <th @click="sortTableCurrencyInt(8)" class="text-center" colspan="2">
                  Cost Interval
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="action in keywordFilteredList" :key="action.id" @click="goToActionView(action.id.toString())">
                <td class="text-start field-opportunity">
                  {{action.action_number}}
                </td>
                <td class="text-start field-site">{{action.status}}</td>
                <td class="text-start field-site">{{action.created_date}}</td>
                <td class="text-start field-number">{{action.seu}}</td>
                <td class="text-start field-opportunity">{{action.event_type}}</td>
                <td class="text-start field-opportunity">{{action.action_to}}</td>
                <td class="text-start field-description" style="padding-right: 12px;">
                  {{ truncatechars(replaceNewlines(action.comment), 500) }}
                  <span v-if="action.response.length > 1" class="font-light-green">  {{ truncatechars(replaceNewlines(action.response), 500) }} </span>
                </td>
                <td class="text-center field-number">{{ action.site_code__currency }} {{action.total_cost_localized.toLocaleString()}}</td>
                <td class="text-center field-number" style="width: 3%;">
                    {{ action.cost_interval }}:
                </td>
                <td class="text-end field-opportunity" style="width: 3%;">
                    <div>{{ action.site_code__currency }} {{ action.cost_localized.toLocaleString() }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { sortTableNew, sortTableCurrencyInt } from "@/common/tables.js";
import { truncatechars } from "@/common/general.js";
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "ActionStandardSearch",
  components: {
      NoPermissionComponent,
  },
  data() {
    return {
      error: null,
      resultCount: null,
      search: "",
      active: "opportunities",
      siteList: null,
      searchQuery: null,
      site: "",
      seu: "",
      status: "open",
      dashboardCurrency: "EUR",
    }
  },
  methods: {
    ...mapGetters(["getUsername", "getServiceSitesAndSeu", "isLoggedIn", "getLoader",
                    "getResultCount", "getActions", "getSiteNames", "getSiteCompanyNames", "getDashboardCurrencies" ]),
    ...mapActions([ "performSetFormError", "fetchAllActions", "fetchServiceSitesAndSeu", "performSetFormError", "fetchSiteNames"]),
    truncatechars: truncatechars,
    sortTableNew: sortTableNew,
    sortTableCurrencyInt: sortTableCurrencyInt,
    replaceNewlines(comment) {
        // Replace newline characters with " | "
        return comment.replace(/\n/g, ' | ');
    },
    getFullActionList() {
      this.fetchAllActions();
    },
    clearSeu() {
        if (this.site === "") {
          this.seu = ""
          this.status = ""
          this.search = ""
        } else {
          this.seu = ""
          this.status = ""
          this.search = ""
        }
    },
    clearSearch() {
       this.search = "";
    },
    goToActionView(id) {
      if (event.ctrlKey === true) {
//        let routeData = this.$router.resolve({ name: 'action-view', params: { id: id } });
//        window.open(routeData.href, '_blank');
        window.open(`/action-details/${id}`, '_blank');
      } else {
//        this.$router.push({ name: 'action-view', params: { id: id } });
//        location.href=(`/action-details/${id}`);
        window.open(`/action-details/${id}`, '_blank');
      }
    },
  },
  computed: {
    filteredList() {
        if (this.seu !== ""  && this.site !== "" && this.status !== "" ) {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() === this.site.toLowerCase() &&
                      action.seu.toLowerCase().includes(this.seu.toLowerCase()) &&
                      action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else if (this.site !== ""  && this.seu === "" && this.status === "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() === this.site.toLowerCase()
            })
        } else if (this.site !== ""  && this.seu !== "" && this.status === "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() === this.site.toLowerCase() &&
                     action.seu.toLowerCase().includes(this.seu.toLowerCase())
            })
        } else if (this.site !== "" && this.seu === "" && this.status !== "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() === this.site.toLowerCase() &&
                     action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else if (this.site === "" && this.seu === "" && this.status !== "") {
            return this.getActions().filter(action => {
              return action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else {
          return this.getActions()
        }
    },
    keywordFilteredList() {
      return this.filteredList.filter(action => {
        return action.action_number.toLowerCase().includes(this.search.toLowerCase()) ||
               action.site_code__site_code.toLowerCase().includes(this.search.toLowerCase()) ||
               action.site_code__site_name.toLowerCase().includes(this.search.toLowerCase()) ||
               action.status.toLowerCase().includes(this.search.toLowerCase()) ||
               action.seu.toLowerCase().includes(this.search.toLowerCase()) ||
               action.event_type.toLowerCase().includes(this.search.toLowerCase()) ||
               action.comment.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  created() {
    this.fetchSiteNames();
    this.fetchServiceSitesAndSeu();
    this.performSetFormError(null);
    this.getFullActionList();
    document.title = "Action Search";
    window.scrollTo(0,0);
  },

}
</script>

